<i *ngIf="show" class="fe fe-lock" [ngClass]="{ 'fa-lg me-2': !small, 'text-muted': muted }"></i>
